import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { FiHeart, FiMapPin } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css"; 
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PageCount from "../../component/utils/PageCount";

function PrivacyPolicy() {
   
  return (
    <section className=" container py-5">

<PageCount pageName = {"Privacy"}/>

       <header>
        <h1> Privacy Policy for Soulsathi.com</h1>
        <p><strong>Effective Date:</strong> November 27, 2025</p>
    </header>

    <p>This Privacy Policy describes how Soulsathi.com (the "Application," "we," "us," or "our") collects, uses, shares, and protects your personal data when you use our mobile application and website (collectively, the "Services"). By using the Services, you agree to the collection and use of information in accordance with this policy.</p>

    <hr/>

    <section>
        <h4>1. Information We Collect</h4>

        <h5>A. Information You Directly Provide</h5>
        <p>This information is essential for profile creation, identity verification, and matchmaking.</p>
        <ul>
            <li><strong>Profile Data:</strong> Name, email, phone number, gender, date of birth, religion, caste, marital status, family details, and partner preferences.</li>
            <li><strong>Verification Information:</strong> Government-issued ID proofs (for verification only), educational and employment certificates.</li>
            <li><strong>Communication Data:</strong> Messages, chat logs, and correspondence with Customer Support.</li>
            <li><strong>Payment Data:</strong> Transaction details processed by third-party payment processors.</li>
        </ul>

        <h5>B. Information Collected Automatically</h5>
        <p>When you use our Services, we automatically collect certain technical and usage data.</p>
        <ul>
            <li><strong>Usage Information:</strong> Access dates, features used, and searches performed.</li>
            <li><strong>Device Information:</strong> Hardware model, operating system, and unique device identifiers.</li>
            <li><strong>Location Data:</strong> Approximate or, with consent, precise geographic location (GPS).</li>
            <li><strong>Cookies and Tracking:</strong> Data collected via cookies and similar technologies to track activity.</li>
        </ul>

        <h5>C. Information from Third Parties</h5>
        <ul>
            <li><strong>Social Media:</strong> If you log in via third-party services (e.g., Google), we receive information according to your privacy settings there.</li>
            <li><strong>Security/Verification Partners:</strong> Data from services assisting with background and anti-fraud checks.</li>
        </ul>
    </section>

    <hr/>

    <section>
        <h4>2. How We Use Your Information</h4>
        <p>The primary purpose of collecting your data is to provide and improve our matchmaking Services. We use your information for the following purposes:</p>
        <ul>
            <li>To Establish and Manage Your Account.</li>
            <li>For Matchmaking and displaying your profile to potential matches.</li>
            <li>To Enable Communication between users.</li>
            <li>For Service Improvement and analysis of user activity.</li>
            <li>For Security and Safety, including fraud prevention and enforcing Terms.</li>
            <li>For Marketing and sending you promotional materials (you can opt-out).</li>
            <li>For Legal Compliance and responding to legal requests.</li>
        </ul>
    </section>

    <hr/>

    <section>
        <h4>3. How We Share Your Information</h4>
        <h5>A. With Other Users</h5>
        <p>Your profile information (photos, age, occupation, etc.) is shared with other users. <strong>Your direct contact information is not shared unless you explicitly choose to do so.</strong></p>

        <h5>B. With Service Providers</h5>
        <p>We share data with third parties necessary to operate the Service, such as hosting, payment processing, analytics, and identity verification partners.</p>

        <h5>C. For Legal and Security Purposes</h5>
        <p>We may disclose information to comply with the law, protect our rights, or ensure the safety of our users.</p>

        <h5>D. Business Transfers</h5>
        <p>Information may be transferred in connection with a merger, acquisition, or sale of assets.</p>
    </section>

    <hr/>

    <section>
        <h4>4. Your Choices and Rights</h4>
        <ul>
            <li><strong>Access and Update:</strong> You can review and update most profile information in the Application.</li>
            <li><strong>Opt-Out of Marketing:</strong> You can unsubscribe from promotional emails.</li>
            <li><strong>Account Deletion:</strong> You may delete your account at any time. We retain some data briefly for legal/safety reasons.</li>
        </ul>
    </section>

    <hr/>

    <section>
        <h4>5. Data Security and Retention</h4>
        <h5>A. Security</h5>
        <p>We use reasonable technical and organizational measures (encryption, firewalls) to protect your data. However, absolute security is not guaranteed.</p>

        <h5>B. Retention</h5>
        <p>We retain data only as long as necessary for the purposes outlined here or as required by law.</p>
    </section>

    <hr/>

    <section>
        <h4>6. Children's Privacy</h4>
        <p>Our Services are not intended for individuals under the legal marriageable age (generally 18 years or older).</p>
    </section>

    <hr/>

    <section>
        <h4>7. Changes to This Privacy Policy</h4>
        <p>We will notify you of any changes by posting the new policy on this page and updating the "Effective Date."</p>
    </section>

    <hr/>

    <section>
        <h4>8. Contact Us</h4>
        <p>If you have any questions or concerns about this policy, please contact us at:</p>
        <p><strong>Soulsathi.com</strong></p>
        <p><strong>Email:</strong> soulsathi.marketing@gmail.com</p>
    </section>
    </section>
  );
}

export default PrivacyPolicy;
